import { Extent } from 'ol/extent'
import TileSource from 'ol/source/Tile'
import { Renderer } from './Renderer'

export class RendererMetadata<TileSourceType extends TileSource> {
    text: string
    value: string
    creator: (type: string) => Renderer<TileSourceType>
    isValidForExtent: (extent: Extent) => boolean
    isSubscriberOnly: boolean
    constructor(text: string, value: string, creator: (type: string) => Renderer<TileSourceType>, isValidForExtent: (extent: Extent) => boolean, isSubscriberOnly: boolean) {
        this.text = text
        this.value = value
        this.creator = creator
        this.isValidForExtent = isValidForExtent
        this.isSubscriberOnly = isSubscriberOnly
    }
}